const CMS_BASE_URL = 'https://api.dev.auxo.dk'

/**
 * Fetch a whole CMS collection via standard array endpoint
 */
export async function getCmsCollection(collectionName) {
  try {
    const res = await fetch(`${CMS_BASE_URL}/public/content/${collectionName}`)
    if (!res.ok) {
      console.warn(`Failed to fetch CMS collection ${collectionName}:`, res.status)
      return []
    }
    const data = await res.json()
    return Array.isArray(data) ? data : []
  } catch (err) {
    console.error(`Error fetching CMS collection ${collectionName}:`, err)
    return []
  }
}

/**
 * Fetch a whole CMS collection via v2 endpoint (paginated/filtered)
 */
export async function getCmsCollectionV2(collectionName, query = {}) {
  try {
    const searchParams = new URLSearchParams()
    Object.entries(query).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        searchParams.append(key, String(val))
      }
    })
    const qs = searchParams.toString()
    const url = `${CMS_BASE_URL}/public/v2/content/${collectionName}${qs ? `?${qs}` : ''}`
    const res = await fetch(url)
    if (!res.ok) {
      console.warn(`Failed to fetch v2 CMS collection ${collectionName}:`, res.status)
      return { items: [], total: 0 }
    }
    const data = await res.json()
    return data || { items: [], total: 0 }
  } catch (err) {
    console.error(`Error fetching v2 CMS collection ${collectionName}:`, err)
    return { items: [], total: 0 }
  }
}

/**
 * Fetch a single entry by slug
 */
export async function getCmsBySlug(lang, slug) {
  try {
    const res = await fetch(`${CMS_BASE_URL}/public/by-slug/${lang}/${slug}`)
    if (!res.ok) return null
    return await res.json()
  } catch (err) {
    console.error(`Error fetching slug ${slug}:`, err)
    return null
  }
}

/**
 * Fetch company information from virksomhedsoplysninger
 */
export async function getCompanyInfo() {
  try {
    const items = await getCmsCollection('virksomhedsoplysninger')
    return items?.[0] || null
  } catch (err) {
    console.error('Error fetching company info:', err)
    return null
  }
}

/**
 * Fetch page details from sider collection
 */
export async function getCmsPage(slugOrTitle) {
  try {
    const items = await getCmsCollection('sider')
    const match = items.find((p) => {
      const pSlug = typeof p.slug === 'object' ? p.slug?.da : p.slug
      return (
        pSlug === slugOrTitle ||
        pSlug === `side-${slugOrTitle}` ||
        p.page_title?.toLowerCase() === slugOrTitle.toLowerCase() ||
        p.id === slugOrTitle
      )
    })
    return match || null
  } catch (err) {
    console.error(`Error fetching page ${slugOrTitle}:`, err)
    return null
  }
}

